module.exports = __webpack_public_path__ + "static/media/givenchy.5dc3d444.jpg";